<template>
  <div>
    <h1 class="mb-1"><span class="text-blue">Dokumen</span> <span class="text-red">Anggota</span></h1>
    <div v-if="$route.matched.length > 3 || $route.meta.breadcumb" class="breadcumb">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2908 11.9997L14.8308 8.4597C15.017 8.27234 15.1216 8.01889 15.1216 7.7547C15.1216 7.49052 15.017 7.23707 14.8308 7.0497C14.7378 6.95598 14.6272 6.88158 14.5054 6.83081C14.3835 6.78004 14.2528 6.75391 14.1208 6.75391C13.9888 6.75391 13.8581 6.78004 13.7362 6.83081C13.6144 6.88158 13.5038 6.95598 13.4108 7.0497L9.1708 11.2897C9.07707 11.3827 9.00268 11.4933 8.95191 11.6151C8.90114 11.737 8.875 11.8677 8.875 11.9997C8.875 12.1317 8.90114 12.2624 8.95191 12.3843C9.00268 12.5061 9.07707 12.6167 9.1708 12.7097L13.4108 16.9997C13.5042 17.0924 13.6151 17.1657 13.7369 17.2155C13.8587 17.2652 13.9892 17.2905 14.1208 17.2897C14.2524 17.2905 14.3829 17.2652 14.5047 17.2155C14.6265 17.1657 14.7374 17.0924 14.8308 16.9997C15.017 16.8123 15.1216 16.5589 15.1216 16.2947C15.1216 16.0305 15.017 15.7771 14.8308 15.5897L11.2908 11.9997Z" fill="#21409A"/>
      </svg>
      <span class="text-blue cursor" @click="$router.go(-1)" style="font-weight: 600;">{{ capitalizeFirstLetter(breadcrumbName) || '' }}</span>
    </div>
    <div class="dok-card">
        <div class="card" v-for="(d, i) in listDokumen" :key="i">
            <div @click="donwloadFile(d.filename)">
                <i class="fas fa-cloud-download-alt"></i>
            </div>
            <div class="text-bold">{{d.doc_name}}</div>
        </div>
    </div>
    <button class="btnSelengkapnya" v-if="page * limit < totalData" @click="loadMore()">
      <span v-if="!loadingMore">Lihat Lebih Banyak<i class="fas fa-chevron-down"></i> </span>
      <span v-else class="button--loading">Loading</span>
    </button>
    <router-view></router-view>
  </div>
</template>

<style lang="scss" scoped>
    .clickable {
      cursor: pointer;
    }
    .breadcumb {
      display: flex;
      align-content: center;
      place-self: center;
      padding: 0 1.5rem;
      cursor: pointer;

      @media only screen and (max-width: 600px) {
        padding: 0;
        margin: -5px;
        margin-bottom: 5px;
        align-content: flex-start;
        justify-content: flex-start;
      }
      &__item {
        font-weight: 600;
      }
    }
    h1 {
        @media only screen and (max-width: 600px) {
            font-size: 16px;
            margin-bottom: 2rem !important;
            margin-top: 2rem;
        }
    }

    .dok-card {
        // display: grid;
        // grid-template-columns: repeat(4, 1fr);
        // grid-gap: 1rem;
        width: 100%;
        @media only screen and (min-width: 601px) and (max-width: 1024px) {
            // grid-template-columns: repeat(3, 1fr);
        }

        @media only screen and (min-width: 301px) and (max-width: 601px) {
            // grid-template-columns: repeat(2, 1fr);
        }

        @media only screen and (max-width: 300px) {
            // grid-template-columns: 1fr;
        }

        .card {
            padding: 2rem 1rem;
            text-align: center;

            i {
                margin-bottom: 2rem;
                cursor: pointer;
            }
        }
    }

    .btnSelengkapnya {
        position: relative;
    }

    .button--loading {
        margin-right: 1rem;
    }

    .button--loading::after {
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        top: 0;
        //   left: 0;
        right: 10px;
        bottom: 0;
        margin: auto;
        border: 4px solid transparent;
        border-top-color: $blue;
        border-radius: 50%;
        animation: button-loading-spinner 1s ease infinite;
    }

    @keyframes button-loading-spinner {
        from {
            transform: rotate(0turn);
        }

        to {
            transform: rotate(1turn);
        }
    }
</style>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      listDokumen: [],
      limit: 20,
      page: 1,
      totalData: null,
      loadMoreBtn: false,
      loadingMore: false,
      isLoad: false
    }
  },
  async mounted () {
    document.title = 'Dashboard - Dokumen'
    // await this.getDoc()
  },
  methods: {
    breadcrumbClicked (index) {
      this.$router.push(this.$route.matched[index + 1].path)
    },
    capitalizeFirstLetter (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    donwloadFile (url) {
      var link = document.createElement('a')
      link.target = '_blank'
      link.href = url
      link.download = url.substr(url.lastIndexOf('/') + 1)
      this.logger(link.download, 'link downloadcasdads')
      link.click()
    },
    async getDoc () {
      this.loadMoreBtn ? this.loadingMore = true : this.isLoad = true
      try {
        const docs = await axios.get(`member/listdocument?limit=${this.limit}&page=${this.page}`)
        if (!this.loadMoreBtn) {
          this.listDokumen = docs.data.data
          this.totalData = docs.data.meta.total_data
          this.isLoad = false
        } else {
          let data = null
          // eslint-disable-next-line no-return-assign
          docs.data.data.forEach(d => data = d)
          this.listDokumen.push(data)
          this.loadingMore = false
        }

        // this.logger(docs, 'dokumen')
      } catch (err) {
        this.isLoad = false
        this.loadingMore = false
        this.logger(err)
      }
    },
    loadMore () {
      this.page += 1
      this.loadMoreBtn = true
      this.getDoc()
      // this.logger(this.page, 'pageee')
    }
  },
  computed: {
    breadcrumbName () {
      return this.$route.params.name || this.$route.meta.breadcumb
    }
  }
}
</script>
